import "../sections.css";

import parse from "html-react-parser";
import useStore from "stores/Store";

function Jumbotron({
  badgeText,
  title,
  buttonText,
  footNotes,
  backgroundImage,
}) {
  const { formRef } = useStore();

  return (
    // <div className="jumbotron">
    <div className="background-color">
      <div
        className="background-img"
        style={
          backgroundImage
            ? { backgroundImage: `url(${backgroundImage})`, height: "40vh" }
            : {}
        }
      >
        <div className="container">
          <div className="jumbotron-container">
            {badgeText && (
              <div className="jumbotron-title col-xl-2">{badgeText}</div>
            )}
            <div className="jumbotron-subtitle col-xl-6">{parse(title)}</div>
            {buttonText && (
              <button
                className="btn btn-primary btn-lg applybtn"
                type="button"
                onClick={() =>{
                  if (formRef.current) {
                    const offset = 156; // Adjust this value as needed
                    const topPosition = formRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
                    window.scrollTo({
                      top: topPosition,
                      behavior: 'smooth'
                    });
                  }
              
                  // formRef?.current?.scrollIntoView({
                  //   block: "start",
                  //   offsetTop: 20,
                  // })
                }}
              >
                Let's connect! 
              </button>
            )}
            {footNotes && (
              <div className="jumbotron-note">
                <i className="bi bi-shield" style={{ margin: "5px" }}></i>
                {footNotes}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}

export default Jumbotron;
